export default __webpack_public_path__ + "static/media/cs-welcome.15fbdcc6.svg";